import React, { useState } from 'react';
import { Box } from '@wix/design-system';
import { ControlService } from '../../types';
import { useTranslation } from '../../../useTranslation';
import { useDebouncedCallback } from '../../common/hooks/useDebouncedCallback';

type BlurControlPSProps = {
  getControl: ControlService['getControl'];
  value: string;
  onChange: (updatedValue: string) => void;
  isMixed: boolean;
  dataHook?: string;
};

export const BlurControlPS: React.FC<BlurControlPSProps> = ({
  getControl,
  value,
  onChange,
  isMixed,
  dataHook,
}) => {
  const [Control] = useState(
    () => getControl('length', 'cssVariableType').Component,
  );
  const [t] = useTranslation();
  const debouncedOnChange = useDebouncedCallback(onChange, 300);

  return (
    <Box direction="vertical" dataHook={dataHook}>
      {Control ? (
        <Control
          minValue={0}
          maxValue={100}
          value={value}
          label={
            isMixed
              ? t('globalDesign.blur_mixed.controller.label')
              : t('globalDesign.blur.controller.label')
          }
          onChange={debouncedOnChange}
        />
      ) : null}
    </Box>
  );
};
